import { render, staticRenderFns } from "./ViewRegister.vue?vue&type=template&id=067fde9a&"
import script from "./ViewRegister.vue?vue&type=script&lang=js&"
export * from "./ViewRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports